import {Container} from "@pg-design/grid-module";
import {HomeIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {IBreadcrumb} from "../../../app/components/breadcrumbs/IBreadcrumb";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {getWhichLabelFromPricesViewType, PricesViewType} from "../helpers/prices_view_type";
import {getDistrictDisplayData} from "../utils/get_district_display_data";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice | null;
    district?: IRegionReportPrice | null;
    /** Plain-text district crumb (no link) - for views where a district page isn't available, e.g. the address page. */
    districtName?: string | null;
    address?: IBreadcrumb | null;
    className?: string;
}

export const PricesBreadcrumbs = (props: IProps) => {
    const district = props.region && props.district ? getDistrictDisplayData(props.district, props.region.slug) : null;

    const items: IBreadcrumb[] = [
        {name: `Ceny ${getWhichLabelFromPricesViewType(props.type)}`, url: rpAppLink.prices.flats.base()},
        ...(props.region ? [{name: props.region.short_name, url: rpAppLink.prices.flats.city({regionSlug: props.region.slug})}] : []),
        ...(props.region && district
            ? [
                  {
                      name: district.name,
                      url: `${rpAppLink.prices.flats.city({regionSlug: props.region.slug})}?dist=${district.slug}`
                  }
              ]
            : []),
        ...(props.districtName ? [{name: props.districtName}] : []),
        ...(props.address ? [props.address] : [])
    ];

    return (
        <div className={props.className}>
            <Container>
                <Breadcrumbs homePageUrl={rpAppLink.base()} homePageIcon={<HomeIcon size="1.4" />} items={items} />
            </Container>
        </div>
    );
};
import {Container} from "@pg-design/grid-module";
import {HomeIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {IBreadcrumb} from "../../../app/components/breadcrumbs/IBreadcrumb";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {getWhichLabelFromPricesViewType, PricesViewType} from "../helpers/prices_view_type";
import {getDistrictDisplayData} from "../utils/get_district_display_data";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice | null;
    district?: IRegionReportPrice | null;
    /** Plain-text district crumb (no link) - for views where a district page isn't available, e.g. the address page. */
    districtName?: string | null;
    address?: IBreadcrumb | null;
    className?: string;
}

export const PricesBreadcrumbs = (props: IProps) => {
    const district = props.region && props.district ? getDistrictDisplayData(props.district, props.region.slug) : null;

    const items: IBreadcrumb[] = [
        {name: `Ceny ${getWhichLabelFromPricesViewType(props.type)}`, url: rpAppLink.prices.flats.base()},
        ...(props.region ? [{name: props.region.short_name, url: rpAppLink.prices.flats.city({regionSlug: props.region.slug})}] : []),
        ...(props.region && district
            ? [
                  {
                      name: district.name,
                      url: `${rpAppLink.prices.flats.city({regionSlug: props.region.slug})}?dist=${district.slug}`
                  }
              ]
            : []),
        ...(props.districtName ? [{name: props.districtName}] : []),
        ...(props.address ? [props.address] : [])
    ];

    return (
        <div className={props.className}>
            <Container>
                <Breadcrumbs homePageUrl={rpAppLink.base()} homePageIcon={<HomeIcon size="1.4" />} items={items} />
            </Container>
        </div>
    );
};
